/* aftership-track.js
   Lightweight script to open AfterShip track pages in the form
   https://www.aftership.com/track/<tracking-number>
   Attach this file to the theme (include via theme.liquid). It looks for
   an input with id="tracking" and a button with id="tracking-btn".
*/
(function () {
  function init() {
    var input = document.getElementById('tracking');
    var btn = document.getElementById('tracking-btn');
    if (!input || !btn) return;

    function openAftershipPath() {
      var val = (input.value || '').trim();
      if (!val) {
        input.focus();
        return;
      }
      // strip leading/trailing slashes and encode
      val = val.replace(/^\/+|\/+$/g, '');
      var url = 'https://www.aftership.com/track/' + encodeURIComponent(val);

      var a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      // ensure new tab cannot access opener
      a.rel = 'noopener noreferrer';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openAftershipPath();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        openAftershipPath();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
